module.exports = __webpack_public_path__ + "img/index-product-scan-green.3eb3012d.png";